// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"c6cf204a","453":"3d81f1e1","629":"bb763f03","640":"e3d1d2b2"}[chunkId] + ".chunk.js";
};